'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('`', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-parse/lib/locate/code-inline.js
// module id = 240
// module chunks = 96961042003272 139266963665775